import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmployment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 6,
		fill: "#E2F0C5"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 15V14C18 12.8954 18.8954 12 20 12H28C29.1046 12 30 12.8954 30 14V15H33C34.6569 15 36 16.3431 36 18V23.7639C36 24.8823 35.359 26.0073 34.1719 26.4058C34.1159 26.4246 34.0586 26.4435 34 26.4624V33C34 34.6569 32.6569 36 31 36H17C15.3431 36 14 34.6569 14 33V26.4624C13.9414 26.4435 13.8841 26.4246 13.8281 26.4058C12.641 26.0073 12 24.8823 12 23.7639V18C12 16.3431 13.3431 15 15 15H18ZM20 14H28V15H20V14ZM16 26.9885V33C16 33.5523 16.4477 34 17 34H31C31.5523 34 32 33.5523 32 33V26.9885C30.8617 27.228 29.51 27.4195 28 27.48V28C28 28.5523 27.5523 29 27 29H21C20.4477 29 20 28.5523 20 28V27.48C18.49 27.4195 17.1383 27.228 16 26.9885ZM33.5354 24.5098C32.3329 24.9134 30.3951 25.3739 28 25.4782V24C28 23.4477 27.5523 23 27 23H21C20.4477 23 20 23.4477 20 24V25.4782C17.6049 25.3739 15.6671 24.9134 14.4646 24.5098C14.2154 24.4261 14 24.1606 14 23.7639V18C14 17.4477 14.4477 17 15 17H33C33.5523 17 34 17.4477 34 18V23.7639C34 24.1606 33.7846 24.4261 33.5354 24.5098ZM26 25H22V27H26V25Z",
		fill: "#55721D"
	})]
});
export default SvgEmployment;
